module.exports = __webpack_public_path__ + "img/bg.8d9aba6f.jpg";